import type { LibraryImageType } from '~/modules/page-builder/types';
import { getPercentageValue, getPixelValue } from '~/utils/math';
import type { Position } from '~/modules/product-tagging/type';
import { convertTagPosition } from './convert-tag-position';

export const getTagPosition = (
    posX: number,
    posY: number,
    {
        WidthBeforeCrop,
        HeightBeforeCrop,
        CropPosX,
        CropPosY,
        WidthAfterCrop,
        HeightAfterCrop,
    }: LibraryImageType,
    boxWidth: number,
    boxHeight: number
): {
    pctAfterOffset: Position;
} => {
    // Give the pixel position on the zoomed in but uncropped image
    let markerX = getPixelValue(posX, WidthBeforeCrop);
    let markerY = getPixelValue(posY, HeightBeforeCrop);

    markerX -= CropPosX;
    markerY -= CropPosY;

    // Convert to percentages
    markerX = getPercentageValue(markerX, WidthAfterCrop);
    markerY = getPercentageValue(markerY, HeightAfterCrop);

    const { pctXAfterOffset, pctYAfterOffset } = convertTagPosition(
        markerX,
        markerY,
        boxWidth,
        boxHeight
    );

    return {
        pctAfterOffset: {
            x: pctXAfterOffset,
            y: pctYAfterOffset,
        },
    };
};
